
const findByRoute = (config, lPath) => {
  const path = `/${lPath.shift()}`;
  const select = config.routes.find(route => route.path === path);
  if (!select) return null;
  if (lPath.length > 0) return findByRoute(select, lPath);
  return select;
};

export const getRouteConfig = state => (route) => { // eslint-disable-line
  console.info('route', route);
  const lPath = route.path.split('/').slice(1);
  return findByRoute(state.config, lPath);
};
